module.exports = __webpack_public_path__ + "9ea7db756dc5252eddd9f96f8723df19.svg";